import { createContext, useState } from "react";

/**
 * The element in the shell's title bar that a page portals its own control
 * into. See `PageHeaderActions.tsx` for why this is a portal and not a node
 * held in context state.
 *
 * Context and hook live here rather than beside the components because a file
 * that exports both components and plain values loses fast refresh
 * (`react-refresh/only-export-components`).
 */
export const PageHeaderSlotContext = createContext<HTMLElement | null>(null);

/** Holds the slot element for the shell. */
export function usePageHeaderSlot() {
  return useState<HTMLElement | null>(null);
}
